<template>
	<div class="card-body card-body--padding--1">
		<h3 class="card-title">Billing details</h3>
		<div class="form-row">
			<div class="form-group col-md-6">
				<label for="checkout-first-name">First Name</label><label class="required-field" >*</label>
				<input type="text" class="form-control" id="checkout-first-name" placeholder="" v-model="billing_fname" @change="updateBillingDetails" :class="errorBName.className">
				<div class="invalid-feedback">{{errorBName.message}}</div>
			</div>
			<div class="form-group col-md-6">
				<label for="checkout-last-name">Last Name</label><label class="required-field" >*</label>
				<input type="text" class="form-control" id="checkout-last-name" placeholder="" v-model="billing_lname" @change="updateBillingDetails">
			</div>
		</div>
		<div class="form-row">
			<div class="form-group col-md-6">
				<label for="checkout-email">Email address</label><label class="required-field" >*</label>
				<input type="email" class="form-control" id="checkout-email" placeholder="" v-model="customeremail" @change="updateBillingDetails" :class="errorBEmail.className">
				<div class="invalid-feedback">{{errorBEmail.message}}</div>
			</div>
			<div class="form-group col-md-6">
				<label for="checkout-phone">Phone</label><label class="required-field" >*</label>
				<input type="text" class="form-control" id="checkout-phone" placeholder="" v-model="billingphone" @change="updateBillingDetails" :class="errorBPhone.className">
				<div class="invalid-feedback">{{errorBPhone.message}}</div>
			</div>
		</div>
		
		<div class="form-group">
			<label for="checkout-street-address">Street Address</label><label class="required-field" >*</label>
			<input type="text" class="form-control" id="checkout-street-address" placeholder="" v-model="billingaddress1" @change="updateBillingDetails" :class="errorBAddress.className">
			<div class="invalid-feedback">{{errorBAddress.message}}</div>
		</div>

		<div class="form-group">
			<label for="checkout-address">Apartment, suite, unit etc. <span class="text-muted">(Optional)</span></label>
			<input type="text" class="form-control" id="checkout-address" v-model="billingaddress2">
		</div>

		<div class="form-group">
			<label for="checkout-city">City</label><label class="required-field" >*</label>
			<input type="text" class="form-control" id="checkout-city" v-model="billingcity" @change="updateBillingDetails" :class="errorBCity.className">
			<div class="invalid-feedback">{{errorBCity.message}}</div>
		</div>

		<div class="form-group">
			<label for="checkout-country">State / Province</label><label class="required-field" >*</label>
			<select id="checkout-country" class="form-control form-control-select2" v-model="billingstate" @change="updateBillingDetails();getTaxRate()" :class="errorBState.className">>
				<option value="AL">Select </option>
				<option value="AL">Alabama</option>
				<option value="AK">Alaska</option>
				<option value="AZ">Arizona</option>
				<option value="AR">Arkansas</option>
				<option value="CA">California</option>
				<option value="CO">Colorado</option>
				<option value="CT">Connecticut</option>
				<option value="DE">Delaware</option>
				<option value="DC">District Of Columbia</option>
				<option value="FL">Florida</option>
				<option value="GA">Georgia</option>
				<option value="HI">Hawaii</option>
				<option value="ID">Idaho</option>
				<option value="IL">Illinois</option>
				<option value="IN">Indiana</option>
				<option value="IA">Iowa</option>
				<option value="KS">Kansas</option>
				<option value="KY">Kentucky</option>
				<option value="LA">Louisiana</option>
				<option value="ME">Maine</option>
				<option value="MD">Maryland</option>
				<option value="MA">Massachusetts</option>
				<option value="MI">Michigan</option>
				<option value="MN">Minnesota</option>
				<option value="MS">Mississippi</option>
				<option value="MO">Missouri</option>
				<option value="MT">Montana</option>
				<option value="NE">Nebraska</option>
				<option value="NV">Nevada</option>
				<option value="NH">New Hampshire</option>
				<option value="NJ">New Jersey</option>
				<option value="NM">New Mexico</option>
				<option value="NY">New York</option>
				<option value="NC">North Carolina</option>
				<option value="ND">North Dakota</option>
				<option value="OH">Ohio</option>
				<option value="OK">Oklahoma</option>
				<option value="OR">Oregon</option>
				<option value="PA">Pennsylvania</option>
				<option value="RI">Rhode Island</option>
				<option value="SC">South Carolina</option>
				<option value="SD">South Dakota</option>
				<option value="TN">Tennessee</option>
				<option value="TX">Texas</option>
				<option value="UT">Utah</option>
				<option value="VT">Vermont</option>
				<option value="VA">Virginia</option>
				<option value="WA">Washington</option>
				<option value="WV">West Virginia</option>
				<option value="WI">Wisconsin</option>
				<option value="WY">Wyoming</option>
				<option value="AB">Alberta</option>
				<option value="BC">British Columbia</option>
				<option value="MB">Manitoba</option>
				<option value="NB">New Brunswick</option>
				<option value="NL">Newfoundland and Labrador</option>
				<option value="NS">Nova Scotia</option>
				<option value="ON">Ontario</option>
				<option value="PE">Prince Edward Island</option>
				<option value="QC">Quebec</option>
				<option value="SK">Saskatchewan</option>
				<option value="NT">Northwest Territories</option>
				<option value="NU">Nunavut</option>
				<option value="YT">Yukon</option>	
			</select>
			<div class="invalid-feedback">{{errorBState.message}}</div>
		</div>

		<div class="form-row">
			<div class="form-group col-md-6">
				<label for="checkout-postcode">ZIP / Postal Code</label><label class="required-field" >*</label>
				<input type="text" class="form-control" id="checkout-postcode" v-model="billingzip" @change="updateBillingDetails();getTaxRate()" :class="errorBZip.className">
				<div class="invalid-feedback">{{errorBZip.message}}</div>
			</div>
			<div class="form-group col-md-6">
				<label for="purchase-order-ID">Purchase Order ID (Optional)</label>
				<input type="text" class="form-control" id="purchase-order-ID" v-model="billingPO" @change="updateBillingDetails" >
			</div>
		</div>

		<div class="form-row">
			<div class="form-group col-md-12">
				<div class="form-group">
					<label for="checkout-business-state">Country</label><label class="required-field">*</label>
					<select id="country" name="country" class="form-control form-control-select2" v-model="billingcountry"  @change="updateBillingDetails" :class="invalidCC_Country.className">
						<option value="USA">United States of America</option>
						<option value="CAN">Canada</option>
						<option value="AFG">Afghanistan</option>
						<option value="ALB">Albania</option>
						<option value="DZA">Algeria</option>
						<option value="ASM">American Samoa</option>
						<option value="AND">Andorra</option>
						<option value="AGO">Angola</option>
						<option value="AIA">Anguilla</option>
						<option value="ATG">Antigua & Barbuda</option>
						<option value="ARG">Argentina</option>
						<option value="ARM">Armenia</option>
						<option value="ABW">Aruba</option>
						<option value="AUS">Australia</option>
						<option value="AUT">Austria</option>
						<option value="AZE">Azerbaijan</option>
						<option value="Bahamas">Bahamas</option>
						<option value="Bahrain">Bahrain</option>
						<option value="Bangladesh">Bangladesh</option>
						<option value="Barbados">Barbados</option>
						<option value="Belarus">Belarus</option>
						<option value="Belgium">Belgium</option>
						<option value="Belize">Belize</option>
						<option value="Benin">Benin</option>
						<option value="Bermuda">Bermuda</option>
						<option value="Bhutan">Bhutan</option>
						<option value="Bolivia">Bolivia</option>
						<option value="Bonaire">Bonaire</option>
						<option value="Bosnia & Herzegovina">Bosnia & Herzegovina</option>
						<option value="Botswana">Botswana</option>
						<option value="Brazil">Brazil</option>
						<option value="British Indian Ocean Ter">British Indian Ocean Ter</option>
						<option value="Brunei">Brunei</option>
						<option value="Bulgaria">Bulgaria</option>
						<option value="Burkina Faso">Burkina Faso</option>
						<option value="Burundi">Burundi</option>
						<option value="Cambodia">Cambodia</option>
						<option value="Cameroon">Cameroon</option>
						<option value="Canary Islands">Canary Islands</option>
						<option value="Cape Verde">Cape Verde</option>
						<option value="Cayman Islands">Cayman Islands</option>
						<option value="Central African Republic">Central African Republic</option>
						<option value="Chad">Chad</option>
						<option value="Channel Islands">Channel Islands</option>
						<option value="Chile">Chile</option>
						<option value="China">China</option>
						<option value="Christmas Island">Christmas Island</option>
						<option value="Cocos Island">Cocos Island</option>
						<option value="Colombia">Colombia</option>
						<option value="Comoros">Comoros</option>
						<option value="Congo">Congo</option>
						<option value="Cook Islands">Cook Islands</option>
						<option value="Costa Rica">Costa Rica</option>
						<option value="Cote DIvoire">Cote DIvoire</option>
						<option value="Croatia">Croatia</option>
						<option value="Cuba">Cuba</option>
						<option value="Curaco">Curacao</option>
						<option value="Cyprus">Cyprus</option>
						<option value="Czech Republic">Czech Republic</option>
						<option value="Denmark">Denmark</option>
						<option value="Djibouti">Djibouti</option>
						<option value="Dominica">Dominica</option>
						<option value="Dominican Republic">Dominican Republic</option>
						<option value="East Timor">East Timor</option>
						<option value="Ecuador">Ecuador</option>
						<option value="Egypt">Egypt</option>
						<option value="El Salvador">El Salvador</option>
						<option value="Equatorial Guinea">Equatorial Guinea</option>
						<option value="Eritrea">Eritrea</option>
						<option value="Estonia">Estonia</option>
						<option value="Ethiopia">Ethiopia</option>
						<option value="Falkland Islands">Falkland Islands</option>
						<option value="Faroe Islands">Faroe Islands</option>
						<option value="Fiji">Fiji</option>
						<option value="Finland">Finland</option>
						<option value="France">France</option>
						<option value="French Guiana">French Guiana</option>
						<option value="French Polynesia">French Polynesia</option>
						<option value="French Southern Ter">French Southern Ter</option>
						<option value="Gabon">Gabon</option>
						<option value="Gambia">Gambia</option>
						<option value="Georgia">Georgia</option>
						<option value="Germany">Germany</option>
						<option value="Ghana">Ghana</option>
						<option value="Gibraltar">Gibraltar</option>
						<option value="Great Britain">Great Britain</option>
						<option value="Greece">Greece</option>
						<option value="Greenland">Greenland</option>
						<option value="Grenada">Grenada</option>
						<option value="Guadeloupe">Guadeloupe</option>
						<option value="Guam">Guam</option>
						<option value="Guatemala">Guatemala</option>
						<option value="Guinea">Guinea</option>
						<option value="Guyana">Guyana</option>
						<option value="Haiti">Haiti</option>
						<option value="Hawaii">Hawaii</option>
						<option value="Honduras">Honduras</option>
						<option value="Hong Kong">Hong Kong</option>
						<option value="Hungary">Hungary</option>
						<option value="Iceland">Iceland</option>
						<option value="Indonesia">Indonesia</option>
						<option value="India">India</option>
						<option value="Iran">Iran</option>
						<option value="Iraq">Iraq</option>
						<option value="Ireland">Ireland</option>
						<option value="Isle of Man">Isle of Man</option>
						<option value="Israel">Israel</option>
						<option value="Italy">Italy</option>
						<option value="Jamaica">Jamaica</option>
						<option value="Japan">Japan</option>
						<option value="Jordan">Jordan</option>
						<option value="Kazakhstan">Kazakhstan</option>
						<option value="Kenya">Kenya</option>
						<option value="Kiribati">Kiribati</option>
						<option value="Korea North">Korea North</option>
						<option value="Korea Sout">Korea South</option>
						<option value="Kuwait">Kuwait</option>
						<option value="Kyrgyzstan">Kyrgyzstan</option>
						<option value="Laos">Laos</option>
						<option value="Latvia">Latvia</option>
						<option value="Lebanon">Lebanon</option>
						<option value="Lesotho">Lesotho</option>
						<option value="Liberia">Liberia</option>
						<option value="Libya">Libya</option>
						<option value="Liechtenstein">Liechtenstein</option>
						<option value="Lithuania">Lithuania</option>
						<option value="Luxembourg">Luxembourg</option>
						<option value="Macau">Macau</option>
						<option value="Macedonia">Macedonia</option>
						<option value="Madagascar">Madagascar</option>
						<option value="Malaysia">Malaysia</option>
						<option value="Malawi">Malawi</option>
						<option value="Maldives">Maldives</option>
						<option value="Mali">Mali</option>
						<option value="Malta">Malta</option>
						<option value="Marshall Islands">Marshall Islands</option>
						<option value="Martinique">Martinique</option>
						<option value="Mauritania">Mauritania</option>
						<option value="Mauritius">Mauritius</option>
						<option value="Mayotte">Mayotte</option>
						<option value="Mexico">Mexico</option>
						<option value="Midway Islands">Midway Islands</option>
						<option value="Moldova">Moldova</option>
						<option value="Monaco">Monaco</option>
						<option value="Mongolia">Mongolia</option>
						<option value="Montserrat">Montserrat</option>
						<option value="Morocco">Morocco</option>
						<option value="Mozambique">Mozambique</option>
						<option value="Myanmar">Myanmar</option>
						<option value="Nambia">Nambia</option>
						<option value="Nauru">Nauru</option>
						<option value="Nepal">Nepal</option>
						<option value="Netherland Antilles">Netherland Antilles</option>
						<option value="Netherlands">Netherlands (Holland, Europe)</option>
						<option value="Nevis">Nevis</option>
						<option value="New Caledonia">New Caledonia</option>
						<option value="New Zealand">New Zealand</option>
						<option value="Nicaragua">Nicaragua</option>
						<option value="Niger">Niger</option>
						<option value="Nigeria">Nigeria</option>
						<option value="Niue">Niue</option>
						<option value="Norfolk Island">Norfolk Island</option>
						<option value="Norway">Norway</option>
						<option value="Oman">Oman</option>
						<option value="Pakistan">Pakistan</option>
						<option value="Palau Island">Palau Island</option>
						<option value="Palestine">Palestine</option>
						<option value="Panama">Panama</option>
						<option value="Papua New Guinea">Papua New Guinea</option>
						<option value="Paraguay">Paraguay</option>
						<option value="Peru">Peru</option>
						<option value="Phillipines">Philippines</option>
						<option value="Pitcairn Island">Pitcairn Island</option>
						<option value="Poland">Poland</option>
						<option value="Portugal">Portugal</option>
						<option value="Puerto Rico">Puerto Rico</option>
						<option value="Qatar">Qatar</option>
						<option value="Republic of Montenegro">Republic of Montenegro</option>
						<option value="Republic of Serbia">Republic of Serbia</option>
						<option value="Reunion">Reunion</option>
						<option value="Romania">Romania</option>
						<option value="Russia">Russia</option>
						<option value="Rwanda">Rwanda</option>
						<option value="St Barthelemy">St Barthelemy</option>
						<option value="St Eustatius">St Eustatius</option>
						<option value="St Helena">St Helena</option>
						<option value="St Kitts-Nevis">St Kitts-Nevis</option>
						<option value="St Lucia">St Lucia</option>
						<option value="St Maarten">St Maarten</option>
						<option value="St Pierre & Miquelon">St Pierre & Miquelon</option>
						<option value="St Vincent & Grenadines">St Vincent & Grenadines</option>
						<option value="Saipan">Saipan</option>
						<option value="Samoa">Samoa</option>
						<option value="Samoa American">Samoa American</option>
						<option value="San Marino">San Marino</option>
						<option value="Sao Tome & Principe">Sao Tome & Principe</option>
						<option value="Saudi Arabia">Saudi Arabia</option>
						<option value="Senegal">Senegal</option>
						<option value="Seychelles">Seychelles</option>
						<option value="Sierra Leone">Sierra Leone</option>
						<option value="Singapore">Singapore</option>
						<option value="Slovakia">Slovakia</option>
						<option value="Slovenia">Slovenia</option>
						<option value="Solomon Islands">Solomon Islands</option>
						<option value="Somalia">Somalia</option>
						<option value="South Africa">South Africa</option>
						<option value="Spain">Spain</option>
						<option value="Sri Lanka">Sri Lanka</option>
						<option value="Sudan">Sudan</option>
						<option value="Suriname">Suriname</option>
						<option value="Swaziland">Swaziland</option>
						<option value="Sweden">Sweden</option>
						<option value="Switzerland">Switzerland</option>
						<option value="Syria">Syria</option>
						<option value="Tahiti">Tahiti</option>
						<option value="Taiwan">Taiwan</option>
						<option value="Tajikistan">Tajikistan</option>
						<option value="Tanzania">Tanzania</option>
						<option value="Thailand">Thailand</option>
						<option value="Togo">Togo</option>
						<option value="Tokelau">Tokelau</option>
						<option value="Tonga">Tonga</option>
						<option value="Trinidad & Tobago">Trinidad & Tobago</option>
						<option value="Tunisia">Tunisia</option>
						<option value="Turkey">Turkey</option>
						<option value="Turkmenistan">Turkmenistan</option>
						<option value="Turks & Caicos Is">Turks & Caicos Is</option>
						<option value="Tuvalu">Tuvalu</option>
						<option value="Uganda">Uganda</option>
						<option value="United Kingdom">United Kingdom</option>
						<option value="Ukraine">Ukraine</option>
						<option value="United Arab Erimates">United Arab Emirates</option>
						<option value="Uraguay">Uruguay</option>
						<option value="Uzbekistan">Uzbekistan</option>
						<option value="Vanuatu">Vanuatu</option>
						<option value="Vatican City State">Vatican City State</option>
						<option value="Venezuela">Venezuela</option>
						<option value="Vietnam">Vietnam</option>
						<option value="Virgin Islands (Brit)">Virgin Islands (Brit)</option>
						<option value="Virgin Islands (USA)">Virgin Islands (USA)</option>
						<option value="Wake Island">Wake Island</option>
						<option value="Wallis & Futana Is">Wallis & Futana Is</option>
						<option value="Yemen">Yemen</option>
						<option value="Zaire">Zaire</option>
						<option value="Zambia">Zambia</option>
						<option value="Zimbabwe">Zimbabwe</option>
					</select>
					<div class="invalid-feedback">{{invalidCC_Country.message}}</div>
				</div>
			</div>
		</div>

		<div class="form-row" v-if="!isLoggedIn">
			<div class="form-group col-md-6">
				<label for="checkout-billing-postcode">Create Password<label class="required-field" >*</label></label>
				<input type="password" class="form-control" id="password" v-model="newpassword" @change="updateNewPassword"  :class="invalidPassword.className">
				<div class="invalid-feedback">{{invalidPassword.message}}</div>
			</div>
			<div class="form-group col-md-6">
				<label for="checkout-billing-postcode">Repeat Password<label class="required-field" >*</label></label>
				<input type="password" class="form-control" id="password-repeat" v-model="repassword" @change="updateNewPassword"  :class="invalidRePassword.className">
				<div class="invalid-feedback">{{invalidRePassword.message}}</div>
			</div>						
		</div>
		<!-- <div class="form-row" v-if="!isLoggedIn">
								
		</div> -->
	</div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';
import ErrorFields from '../../../mixins/ErrorFields.js';

export default {
	mixins: [ErrorFields],
	props: {
        name: {
            type: String
        },
        address1: {
            type: String
        },
        address2: {
            type: String
        },
        city: {
            type: String
        },
        state: {
            type: String
        },
        zip: {
            type: String
        },
        country: {
            type: String
        },
        phone: {
			type: String
        },
        email: {
            type: String
        },
    },
	data () {
		return {
			// billing_fname: 'Nick',
			// billing_lname: 'Zordan',
            // billingaddress1: '1234 Ocean',
            // billingaddress2: '',
            // billingcity: 'Boca Raton',
            // billingstate: 'FL',
            // billingzip: '33433',
            // billingphone: 8889852500,
			// billingPO: 'existing b2c 1',
            // customeremail: 'nicola@DMS-systems.com',
			tax_rate: 0,
			isLoggedIn : false,

			billing_fname: '',
			billing_lname: '',
            billingaddress1: '',
            billingaddress2: '',
            billingcity: '',
            billingstate: '',
            billingzip: '',
            billingphone: '',
            billingcountry: 'USA',
			billingPO: '',
            customeremail: '',

			newpassword: '',
			repassword: '',
		};
	},
	methods: {
		updateBillingDetails() {

            this.$store.dispatch('cart/billingdetails', {
                "email": this.customeremail,
                "phone": this.billingphone,
                "billingname": this.billing_fname + ' ' + this.billing_lname,
                "billingaddress1": this.billingaddress1,
                "billingaddress2": this.billingaddress2,
                "billingcity": this.billingcity,
                "billingstate": this.billingstate,
                "billingcountry": this.billingcountry,
                "billingzip": this.billingzip,
                "billingphone": this.billingphone,
            });
        },

		updateNewPassword() {
			this.$store.dispatch('setPassword', {
                newpassword: this.newpassword,
                repassword: this.repassword,
            });
		},

		getCustomerInfo() {
            this.isloading = true;
            this.servermessages = [];

            this.billingname = '', this.billingaddress1 = '', this.billingaddress2 = '', this.billingcity = '', this.billingstate = '', this.billingzip = '', this.billingphone = '', this.shippingname = '', this.shippingaddress1 = '', this.shippingaddress2 = '', this.shippingcity = '', this.shippingstate = '', this.shippingzip = '', this.shippingphone = '', this.customeremail = '';

            axiosvl.post(this.$store.getters['api/get_customer_info_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                let messages = [];

                if (fields.RESULTCOD.value === 'OK') {

					const names = fields.ADNAME.value.split(" ");
					if (names.length > 1){
						this.billing_fname = names[0];
						this.billing_lname = names[1];
					}else{
						this.billing_fname = names[0];
					}
                    this.billingaddress1 = fields.ADADD1.value;
                    this.billingaddress2 = fields.ADADD2.value;
                    this.billingcity = fields.ADCITY.value;
                    this.billingstate = fields.ADSTTC.value;
                    this.billingzip = fields.ADZIPC.value;
                    this.billingcountry = (fields.ADCTRC.value != '') ? fields.ADCTRC.value : this.billingcountry;
                    this.billingphone = fields.ADPHON.value;
                    this.CMNAME = fields.CMNAME.value;
                    this.ADCNNM = fields.ADCNNM.value;
                    this.S2CNNM = fields.S2CNNM.value;
                    if (fields.S2NAME.value === '' && fields.S2ADD1.value === '') {
                        this.shippingname = fields.ADNAME.value;
                        this.shippingaddress1 = fields.ADADD1.value;
                        this.shippingaddress2 = fields.ADADD2.value;
                        this.shippingcity = fields.ADCITY.value;
                        this.shippingstate = fields.ADSTTC.value;
                        this.shippingzip = fields.ADZIPC.value;
                        this.shippingphone = fields.ADPHON.value;
                    } else {
                        this.shippingname = fields.S2NAME.value;
                        this.shippingaddress1 = fields.S2ADD1.value;
                        this.shippingaddress2 = fields.S2ADD2.value;
                        this.shippingcity = fields.S2CITY.value;
                        this.shippingstate = fields.S2STTC.value;
                        this.shippingzip = fields.S2ZIPC.value;
                        this.shippingcountry = fields.S2CTRC.value;
                        this.shippingphone = fields.S2PHON.value;
                    }

                    this.customeremail = fields.ECEMAL.value;

                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }
				
				this.getTaxRate();
				this.updateBillingDetails();

				this.$store.dispatch('cart/shippingdetails', {
					"shippingname": fields.S2NAME.value,
					"shippingaddress1": fields.S2ADD1.value,
					"shippingaddress2": fields.S2ADD2.value,
					"shippingcity": fields.S2CITY.value,
					"shippingstate": fields.S2STTC.value,
					"shippingcountry": fields.S2CTRC.value,
					"shippingzip": fields.S2ZIPC.value,
					"shippingphone": fields.S2PHON.value,
					carrier : this.CMCARR
					// "carrier": "UPS-1",
				});

                this.isloading = false;
                this.servermessages = messages;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

		getTaxRate(){

			if(!this.billingzip || !this.billingstate){
				return false;
			}
			
			const tax_rate_uri = this.$store.getters['api/tax_rate_uri'];
            const params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        // "HOSTURL": {"value": this.$store.getters.hosturl},
						"LW3SFID": { "value": this.$store.getters.storefront },
                        "LW3TZIPCD": {
                            "value": this.billingzip
                        },
                        "LW3TXSTAT": {
                            "value": this.billingstate
                        },
                    }
                }
            };

            axiosvl.post(tax_rate_uri, params)
            .then((response) => {
                const fields = response.data.webroutine.fields
                this.tax_rate = parseFloat(fields.LW3TXRATE.value) + 1;

                const with_tax = parseFloat(this.totals[0].ordertotal) * this.tax_rate;
                const tax_amount = with_tax - parseFloat(this.totals[0].ordertotal);
                this.totals[0].taxtotal = tax_amount;
                this.totals[0].ordertotal = with_tax;

				this.$store.dispatch("cart/update_tax_rate", {tax_rate : fields.LW3TXRATE.value});

                this.$store.dispatch("cart/totals", this.totals[0]);
                this.$store.dispatch("cart/calculateTotals");
            })
            .catch((error) => {
                // this.isloading = false;
                console.log("error - " + error);
            });
        }
	},

	watch: {
		billingphone(val) {
			const strPhone = this.billingphone.toString();
			this.billingphone = strPhone.replace(/[^0-9-]*$/gi, '');
			
			this.billingphone = this.billingphone.substring(0, 12);
			
			if(val != ''){
				this.errorBPhone.message = '';
				this.errorBPhone.className = '';
			}
		},

		billing_fname(val){
			if(val != ''){
				this.errorBName.message = '';
				this.errorBName.className = '';
			}
		},

		billing_lname(val){
			if(val != ''){
				this.errorBName.message = '';
				this.errorBName.className = '';
			}
		},

		customeremail(val) {
			if(val != ''){
				this.errorBEmail.message = '';
				this.errorBEmail.className = '';
			}
		},
		
		billingaddress1(val) {
			if(val != ''){
				this.errorBAddress.message = '';
				this.errorBAddress.className = '';
			}
		},

		billingcity(val) {
			if(val != ''){
				this.errorBCity.message = '';
				this.errorBCity.className = '';
			}
		},

		billingstate(val) {
			if(val != ''){
				this.errorBState.message = '';
				this.errorBState.className = '';
			}
		},

		billingzip(val) {
			if(val != ''){
				this.errorBZip.message = '';
				this.errorBZip.className = '';
			}
		},

		billingcountry(val){
			if(val != ''){
				this.invalidCC_Country.message = '';
				this.invalidCC_Country.className = '';
			}
		},

		newpassword(val){
			if(val != ''){
				this.invalidPassword.message = '';
				this.invalidPassword.className = '';
			}
		},

		repassword(){
			if(this.newpassword != this.repassword){
				this.invalidRePassword.message = 'Password is not matched.';
				this.invalidRePassword.className = 'is-invalid';
			}else{
				this.invalidRePassword.message = '';
				this.invalidRePassword.className = '';
			}
		},

	},

	computed: {
        ...mapGetters("cart", [
            "totals",
        ]),		
    },

	created() {
		this.isLoggedIn = this.$store.getters.userIsAuthenticated;
		
		if(this.isLoggedIn){
			this.getCustomerInfo();
		}
        this.updateBillingDetails();

		this.getTaxRate();
    },

	updated() {
		if(this.isLoggedIn){
			// const names = this.name.split(" ");
			// if (names.length > 1){
			// 	this.billing_fname = names[0];
			// 	this.billing_lname = names[1];
			// }else{
			// 	this.billing_fname = names[0];
			// }

			// this.billingaddress1 = this.address1;
            // this.billingaddress2 = this.address2;
            // this.billingcity = this.city;
            // this.billingstate = this.state;
            // this.billingzip = this.zip;
            // this.billingphone = this.phone;
            // this.billingcountry = this.country;
            // this.customeremail = this.email;
			// console.log('count');
			// this.getCustomerInfo();
		}
	},
}
</script>